export default [
  {
    name: 'Dashboard',
    icon: 'ti-home',
    path: '/admin/dashboard'
  },
  {
    name: 'My Brands',
    icon: 'ti-stamp',
    path: '/admin/brands'
  },
  {
    name: 'Retailers',
    icon: 'ti-agenda',
    path: '/admin/retailers'
  },
  {
    name: 'Products',
    icon: 'ti-package',
    path: '/admin/products'
  },
  {
    name: 'Label Creator',
    icon: 'ti-lock',
    path: '/admin/make-auth-codes'
  },
  {
    name: 'Registrations',
    icon: 'ti-shield',
    path: '/admin/validations'
  },
  {
    name: 'Account',
    icon: 'ti-user',
    path: '/admin/account'
  },
  // {
  //   name: 'Fraud Reports',
  //   icon: 'ti-alert',
  //   path: '/admin/fraud-reports'
  // },
  {
    name: 'Log Out',
    icon: 'ti-power-off',
    path: '/login?logout=true'
  }/*,
  {
    name: 'Edit Profile',
    icon: 'ti-user',
    path: '#'
  },
  {
    name: 'Payment Settings',
    icon: 'ti-money',
    path: '#'
  }
  */
]



// WEBPACK FOOTER //
// ./src/sidebarLinks.js